import { API } from "@/lib/api";

/** Public URL for serving a photo file — no auth required. */
export function photoFileUrl(photoId) {
  if (!photoId) return "";
  return `${API}/gallery/photos/${photoId}/file`;
}
